import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { WorkflowEventPayloadsExamples } from "schema"
import { useWorkflowBuilder } from "./useWorkflowBuilder"

type UseEventPayloadProps = {
  nodeId: string
}

export function useEventPayload({ nodeId }: UseEventPayloadProps) {
  const { form } = useWorkflowBuilder()
  const { t } = useTranslation()

  const nodes = form.watch("nodes")

  const eventNode = useMemo(() => {
    if (!nodes || nodes.length === 0 || !nodeId) return null

    // Find parent event node by traversing up the tree
    let currentNode = nodes.find((n) => n.id === nodeId)
    while (currentNode) {
      if (currentNode.type === "Event") {
        return currentNode
      }
      currentNode = nodes.find((n) => n.id === currentNode?.parentId)
    }

    return null
  }, [nodes, nodeId])

  const eventPayload = useMemo(() => {
    if (!eventNode?.event) return null

    return WorkflowEventPayloadsExamples[eventNode.event]
  }, [eventNode])

  const eventName = eventNode?.event ? t(`campaigns.event.options.${eventNode.event}.label`) : null

  return {
    eventNode,
    eventPayload,
    eventName,
  }
}
